import { render, staticRenderFns } from "./modalHorasIntraBase.vue?vue&type=template&id=2f7ffc17&scoped=true&"
import script from "./modalHorasIntraBase.vue?vue&type=script&lang=js&"
export * from "./modalHorasIntraBase.vue?vue&type=script&lang=js&"
import style0 from "./modalHorasIntraBase.vue?vue&type=style&index=0&id=2f7ffc17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7ffc17",
  null
  
)

export default component.exports